/**
 * Page transitions - 8 cinematic arcane effects on route change.
 * One is chosen randomly each navigation.
 */

const TRANSITIONS = [
  'grimoire',
  'void',
  'dissolve',
  'warp',
  'shatter',
  'smoke',
  'glitch',
  'rise',
] as const;

type TransitionType = (typeof TRANSITIONS)[number];

const EXIT_DURATIONS: Record<TransitionType, number> = {
  grimoire: 350,
  void: 300,
  dissolve: 400,
  warp: 300,
  shatter: 350,
  smoke: 350,
  glitch: 250,
  rise: 300,
};

const ENTER_DURATIONS: Record<TransitionType, number> = {
  grimoire: 400,
  void: 400,
  dissolve: 500,
  warp: 400,
  shatter: 450,
  smoke: 400,
  glitch: 300,
  rise: 400,
};

export function initPageTransitions(): () => void {

  let prevHash = location.hash;
  let transitioning = false;

  function pickRandom(): TransitionType {
    return TRANSITIONS[Math.floor(Math.random() * TRANSITIONS.length)] ?? 'void';
  }

  function onHashChange() {
    const main = document.querySelector('main.app-main') as HTMLElement | null;
    if (!main) return;

    const newHash = location.hash;
    if (newHash === prevHash || transitioning) return;
    prevHash = newHash;
    transitioning = true;

    const effect = pickRandom();
    const exitClass = `page-${effect}-exit`;
    const enterClass = `page-${effect}-enter`;

    main.classList.add(exitClass);

    setTimeout(() => {
      main.classList.remove(exitClass);
      main.classList.add(enterClass);

      setTimeout(() => {
        main.classList.remove(enterClass);
        transitioning = false;
      }, ENTER_DURATIONS[effect]);
    }, EXIT_DURATIONS[effect]);
  }

  window.addEventListener('hashchange', onHashChange);
  return () => window.removeEventListener('hashchange', onHashChange);
}
